<template>
  <div>
    <SGPRowComponent class="flex-row items-center">
      <SGPColComponent cols="3">
        <h1>
          {{ titulo }}

          <span class="d-block" style="margin-top: -12px; color: #666; font-weight: 400;" v-if="subtitulo">
            <small class="font-size-15">
              {{ subtitulo }}
            </small>
          </span>
        </h1>
      </SGPColComponent>

      <SGPColComponent cols="9">
        <SGPRowComponent>
          <SGPColComponent class="">
            
            

            <SGPFormBotaoComponent
              color="error darken-1"
              class="float-right mt-3"
              v-if="mostrarBotaoFiltroAvancado"
              @click="abrirFiltroAvancado"
            >
              <v-icon                
                small
                class="mr-2"
              >
                mdi-filter
              </v-icon> 
              Filtro Avançado
            </SGPFormBotaoComponent>

            <SGPFormInputComponent
              v-model="textoBusca"
              v-if="mostrarBusca"
              rounded
              placeholder="O que você deseja buscar?"
              class="float-right margin-right-20"
              style="width: 290px;"
              single-line
              append-icon="mdi-magnify" 
              @input="emitTextoBusca"
            />

            <slot></slot>
            
          </SGPColComponent>

        </SGPRowComponent>

      </SGPColComponent>

    </SGPRowComponent>

  </div>
</template>

<script>
export default {
  name: 'SGPPageHeaderComponent',

  props: {
    titulo: {
      type: String,
      required: true,
      default: ''
    },

    subtitulo: {
      type: String,
      required: false,
      default: ''
    },

    mostrarBusca: {
      type: Boolean,
      required: false,
      default: false
    },

    textoBusca: {
      type: String,
      required: true,
      default: ''
    },

    mostrarBotaoFiltroAvancado: {
      type: Boolean,
      required: false,
      default: false
    }

  },

  data () {
    return {
      abrirFiltro: false
    }
  },

  methods: {
    emitTextoBusca () {
      this.$emit('emitTextoBusca', this.textoBusca)
    },

    abrirFiltroAvancado () {
      this.abrirFiltro = !this.abrirFiltro
      this.$emit('emitAbrirFiltro', this.abrirFiltro)
    }
  }
}
</script>

<style scoped>
  h1 { 
    font-size: 32px;
    color: #51555D;
    font-weight: 500;
  }

  .padding-button {
    padding: 22px 14px !important;
    margin-top: -6px !important;
  }

  .no-uppercase {
    text-transform: unset !important;
  }

</style>